/**
 * Recruitment Utilities
 * Contains utility functions for recruitment-related operations.
 * 
 * @file recruitment.utils.ts
 * @version 1.0
 * @since 2025-01-19
 */

import { TypeRecrutement } from '@models/domains/recruitment';

/**
 * Utility class for recruitment-related operations
 */
export class RecruitmentUtils {
  
  /**
   * The definitive list of vacataire recruitment type codes
   */
  private static readonly VACATAIRE_CODES = ['ACR', 'SAIS', 'APP'] as const;
  
  /**
   * Determines if a recruitment type is a "vacataire" type
   * 
   * Vacataire types are:
   * - ACR: RECRUTEMENT POUR ACCROISSEMENT TEMPORAIRE D'ACTIVITÉ (ATA)
   * - SAIS: RECRUTEMENT POUR BESOIN SAISONNIER (SA)
   * - APP: RECRUTEMENT POUR CONTRAT D'APPRENTISSAGE (PR)
   * 
   * @param typeRecrutement The recruitment type to check
   * @returns true if the recruitment type is vacataire, false otherwise
   */
  static isVacataireType(typeRecrutement: TypeRecrutement | null | undefined): boolean {
    if (!typeRecrutement?.code) {
      return false;
    }
    
    return this.VACATAIRE_CODES.includes(typeRecrutement.code as any);
  }
  
  /**
   * Gets the list of vacataire type codes
   * 
   * @returns Array of vacataire type codes
   */
  static getVacataireCodes(): readonly string[] {
    return this.VACATAIRE_CODES;
  }
}